<script>
import MinimalLayout from '@/components/layouts/minimal/MinimalLayout';
import animate from '@/modules/animate-css';

export default {
  name: 'Login',
  components: {
    MinimalLayout
  },
  metaInfo() {
    return { title: this.title };
  },
  data() {
    return {
      title: this.$t('Login'),
      email: '',
      invalid: [],
      isLoggingIn: false,
      isTrusted: false,
      password: ''
    };
  },
  mounted() {
    this.$refs.email.focus();
  },
  methods: {
    handleSubmit() {
      this.invalid = [];
      this.isLoggingIn = true;

      // Log the user in
      this.$http
        .post('/auth/login', {
          email: this.email,
          password: this.password,
          isTrusted: this.isTrusted
        })
        .then(res => {
          // Store the user
          this.$store.commit('setUser', res.data.user);
          this.$store.commit('setTfa', {
            isRequiredByAccount: res.data.user.account.requiresTfa,
            isRequired: res.data.user.requiresTfa,
            isVerified: false
          });
        })
        // Send a subsequent request to fetch new metadata
        .then(() => this.$http('/auth/session'))
        .then(res => this.$store.commit('setMetadata', res.data.metadata))
        .then(() => {
          if (this.$store.state.user.requiresTfa) {
            // If two-factor auth is required, move on to the next page and forward the ?to param
            this.$router.push({ name: 'LoginTfa', query: { to: this.$route.query.to } });
          } else {
            // If two-factor auth isn't required, redirect to the homepage or to the specified ?to
            if (this.$route.query.to) {
              this.$router.push(this.$route.query.to);
            } else {
              this.$router.push({ name: 'Home' });
            }
          }
        })
        .catch(err => {
          const data = err.response.data;
          const status = err.response.status;

          if (status === 400) {
            this.invalid = Array.isArray(data.invalid) ? data.invalid : [];
            animate(document.querySelector('.minimal-body'), 'shake', 1.25);
          } else {
            this.$notify({
              type: 'error',
              title: this.$t('Error'),
              message: this.$t('An error occurred. Please try your request again later.')
            });
          }
        })
        .finally(() => (this.isLoggingIn = false));
    }
  }
};
</script>

<template>
  <minimal-layout>
    <el-form ref="loginForm" label-position="top" @submit.native.prevent="handleSubmit">
      <!-- Email -->
      <el-form-item :class="{ 'is-error': invalid.includes('email') }">
        <el-input
          ref="email"
          v-model="email"
          :placeholder="$t('Email')"
          prefix-icon="el-icon-fa-envelope"
          type="email"
          auto-complete="off"
        />
      </el-form-item>

      <!-- Password -->
      <el-form-item :class="{ 'is-error': invalid.includes('password') }">
        <el-input
          v-model="password"
          :placeholder="$t('Password')"
          prefix-icon="el-icon-fa-lock"
          type="password"
          auto-complete="off"
        />
      </el-form-item>

      <!-- Remember -->
      <el-form-item>
        <el-checkbox v-model="isTrusted" :checked="isTrusted" auto-complete="off">
          {{ $t('Remember This Device') }}
        </el-checkbox>
      </el-form-item>

      <!-- Login button -->
      <el-form-item>
        <el-button :loading="isLoggingIn" type="primary" native-type="submit" class="el-button--block">
          {{ $t('Login') }}
        </el-button>
      </el-form-item>

      <!-- Password link -->
      <div class="text-center">
        <small>
          <router-link :to="{ name: 'RecoverPassword' }">
            {{ $t('Forgot your password?') }}
          </router-link>
        </small>
      </div>
    </el-form>
  </minimal-layout>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

//
// No styles yet
//
</style>
